/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'shared';
const componentName = 'file-upload';
const prefix = `${moduleName}.${componentName}`;

export const selectFileInputLabel = `${prefix}.selectFileInputLabel`;
export const maxSizeExceededAlertMessage = `${prefix}.maxSizeExceededAlertMessage`;
export const importFileInputLabel = `${prefix}.importFileInputLabel`;

export const ENGLISH = {
    [selectFileInputLabel]: 'Select a file',
    [maxSizeExceededAlertMessage]: 'File size should be under {0} MB',
    [importFileInputLabel]: 'Import File',
};
